import React from 'react';
import { string, elementType } from 'prop-types';

const Page = ({ workflowState, component, state }) => {
  if (state !== workflowState) {
    return null;
  }
  const Component = component;
  return <Component />;
};

Page.propTypes = {
  workflowState: string.isRequired,
  component: elementType.isRequired,
  state: string.isRequired,
};

export default Page;
